import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const StyledConversationListSkeletonContainer = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 3}px;
        overflow-y: auto;
    `
)

export const StyledConversationItemSkeleton = styled(Flexbox)(
    ({theme: {spacing, palette}}) => css`
        padding: 0px ${spacing * 3}px;
        border-radius: 8px;
        background-color: ${palette.neutral.white};
        border: 1px solid ${palette.neutral[200]};
    `
)

export const StyledConversationContentSkeleton = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 3}px 0px ${spacing * 2}px;
    `
)

export const StyledConversationFooterSkeleton = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding: 0px 0px ${spacing * 2}px;
    `
)
